import React from "react";
import {Modal} from "../../../components/shared/Modal/Modal";

interface DeleteRecommendationModalProps {
    show: boolean;
    onClose: () => void;
    onDelete: () => void;
    recommendationName: string;
}

const DeleteRecommendationModal: React.FC<DeleteRecommendationModalProps> = ({
    show,
    onClose,
    onDelete,
    recommendationName
}) => {
    return (
        <Modal
            show={show}
            onClose={onClose}
            title={"Удалить рекомендацию"}
            showSave={false}
            showDelete={true}
            onDelete={onDelete}
            disabledSave={false}
        >
            <div style={{padding: '16px', textAlign: 'center'}}>
                <p>Вы точно хотите удалить рекомендацию?</p>
                <strong>{recommendationName}</strong>
            </div>
        </Modal>
    );
};

export default DeleteRecommendationModal;
